"use client";

import React, { useEffect } from "react";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import AboutIntroducionSection from "@/components/common/FirstBlockAbout";
import PHPLogo from "@/app/components/icons/PHPLogo";
import WordpressLogo from "@/app/components/icons/WordpressLogo";

export default function GeorgeStreetLofts() {
    const primaryColor = "#a67131";

    useEffect(() => {
        const link = document.createElement("link");
        link.href =
            "https://fonts.googleapis.com/css2?family=Cormorant:ital,wght@0,300..700;1,300..700&family=Inter+Tight:ital,wght@0,100..900;1,100..900&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap'";
        link.rel = "stylesheet";
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return (
        <>
            <section className="flex flex-col gap-[100px] my-[35px]">
                <div>
                    <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2Flogo-v2.svg?alt=media&token=e7d3e05e-dc58-409e-9e47-f5e31882c891" />
                    <AboutIntroducionSection
                        media={{
                            type: "image",
                            src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2FIMG_3541.webp?alt=media&token=166162b0-981d-4cef-a5fa-a026b7188256",
                        }}
                        primaryColor={primaryColor}
                    />
                    <WebsiteSubtitle
                        text="For George Street Lofts, we developed a digital platform that reflects the unique character of urban loft living in the heart of Toronto. Our goal was to blend the building's industrial heritage with a clean, contemporary design that appeals to modern city dwellers. We focused on high-quality visual storytelling, integrating an interactive suite gallery and detailed building amenities. The website provides a seamless user journey, allowing potential residents to explore the distinctive architecture, view floor plans, and connect with the leasing team through a streamlined, conversion-focused interface."
                        title="Deliverables"
                        tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
                        buttonHref="https://georgestreetlofts.ca/"
                    />
                </div>

                <PortfolioTypography
                    typographyData={[
                        {
                            headline: "Industrial Heritage, Modern Living: redefining the essence of urban lofts in Toronto.",
                            fontFamily: "Cormorant",
                            fontSize: "56px",
                            letterSpacing: "0%",
                            lineHeight: "115%",
                            textColor: "#2c2d2c",
                        },
                    ]}
                    primaryColor={primaryColor}
                />
                <PortfolioColorscheme
                    ColorschemeData={[
                        {
                            title: "Golden Brown",
                            color: "#A67131",
                            rgb: "#A67131",
                            textColor: "#fff",
                        },
                        {
                            title: "Black",
                            color: "#2C2D2C",
                            rgb: "#2C2D2C",
                            textColor: "#FFFFFF",
                        },
                        {
                            title: "White",
                            color: "#FFFFFF",
                            rgb: "#FFFFFF",
                            textColor: "#2c2d2c",
                        },
                        {
                            title: "Deep Espresso",
                            color: "#4D4337",
                            rgb: "#4D4337",
                            textColor: "#fff",
                        },
                    ]}
                    primaryColor={primaryColor}
                />
                <PortfolioResponsiveDisplays
                    ResponsiveDisplaysData={[
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2FgslMac.png?alt=media&token=51c573c9-4cef-4ca7-85dd-0611fc544732",
                        },
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2Fgslipad.png?alt=media&token=6721f005-d842-463b-b523-ec6c4c7dbd2d",
                        },
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2Fgsliphone.png?alt=media&token=0b734b78-2ee6-4585-bd00-c6d0fb2e5030",
                        },
                    ]}
                    primaryColor={primaryColor}
                />
                <PortfolioTechStack
                    primaryColor={primaryColor}
                    blocks={[
                        {
                            title: "Design",
                            titleColor: "#2c2d2c",
                            icons: [<FigmaLogo key="figma" />],
                            opacity: 5,
                        },
                        {
                            title: "Layout Development",
                            titleColor: "#2c2d2c",
                            icons: [<HTML5Logo key="html" />, <CSS3Logo key="css" />, <JSLogo key="js" />],
                            opacity: 15,
                        },
                        {
                            title: "Theme Development",
                            titleColor: "#2c2d2c",
                            icons: [<PHPLogo key="php" />],
                            opacity: 25,
                        },
                        {
                            title: "Publishing",
                            titleColor: "#2c2d2c",
                            icons: [<WordpressLogo key="wp" />],
                            opacity: 30,
                        },
                    ]}
                />
            </section>
        </>
    );
}
